import { render } from "./InformationCircle.vue?vue&type=template&id=68580b2a"
import script from "./InformationCircle.vue?vue&type=script&lang=js"
export * from "./InformationCircle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "68580b2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68580b2a', script)) {
    api.reload('68580b2a', script)
  }
  
  module.hot.accept("./InformationCircle.vue?vue&type=template&id=68580b2a", () => {
    api.rerender('68580b2a', render)
  })

}

script.__file = "src/icons/components/outlined/InformationCircle.vue"

export default script